import { PropsWithChildren } from 'react';
import { IconName } from '@optimus-web/icons';
import { compactArray } from '@mews/fp';
import { LocalizedText, useDialog, useFeatureFlag } from '@mews/framework';
import { ActionType, ArticlePath, createGuideLink, FeatureFlag, TextKey } from '@mews-commander/enums';
import { Breadcrumbs } from '@mews-commander/modules/src/components';
import { HeadingAction } from '@mews-commander/modules/src/legacy';
import { useEnterpriseNavigate } from '@mews-commander/ui';
import { CreateRoleDialog } from '../CreateRole';
import { PropertyLayoutWrapper } from './PropertyLayoutWrapper';

export const PropertyRolesLayout = ({ children }: PropsWithChildren<{}>) => {
    const [createRoleDialogProps, toggleCreateRoleDialog] = useDialog();
    const newPermissionsEnabled = useFeatureFlag(FeatureFlag.newPermissionsEnabled);
    const navigate = useEnterpriseNavigate();

    const breadcrumbs: Breadcrumbs = [{ text: <LocalizedText textKey={TextKey.Roles} />, active: true }];

    const actions: HeadingAction[] = compactArray([
        newPermissionsEnabled
            ? {
                  onClick: async () => navigate({ to: 'Roles/CreateRole' }),
                  icon: IconName.Add,
                  text: <LocalizedText textKey={TextKey.RoleCreateLocalTitle} />,
                  'data-test-icon-button': IconName.Add,
                  type: ActionType.Link,
              }
            : {
                  onClick: toggleCreateRoleDialog,
                  icon: IconName.Add,
                  text: <LocalizedText textKey={TextKey.RoleCreateLocalTitle} />,
                  'data-test-icon-button': IconName.Add,
                  type: ActionType.Link,
              },
        {
            url: createGuideLink(ArticlePath.SetUpAndCustomizeUserRoles),
            target: '_blank',
            icon: IconName.Help,
            text: <LocalizedText textKey={TextKey.Help} />,
            type: ActionType.Link,
        },
    ]);

    return (
        <PropertyLayoutWrapper actions={actions} breadcrumbs={breadcrumbs}>
            {children}
            <CreateRoleDialog {...createRoleDialogProps} />
        </PropertyLayoutWrapper>
    );
};
